/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_TRANSPORTERS = 'REQUEST_TRANSPORTERS';
export const REQUEST_TRANSPORTERS_SUCCESS = 'REQUEST_TRANSPORTERS_SUCCESS';
export const REQUEST_TRANSPORTERS_FAILURE = 'REQUEST_TRANSPORTERS_FAILURE';

export const REQUEST_TRANSPORTER = 'REQUEST_TRANSPORTER';
export const REQUEST_TRANSPORTER_SUCCESS = 'REQUEST_TRANSPORTER_SUCCESS';
export const REQUEST_TRANSPORTER_FAILURE = 'REQUEST_TRANSPORTER_FAILURE';

export const REQUEST_ADD_TRANSPORTER = 'REQUEST_ADD_TRANSPORTER';
export const REQUEST_ADD_TRANSPORTER_SUCCESS = 'REQUEST_ADD_TRANSPORTER_SUCCESS';
export const REQUEST_ADD_TRANSPORTER_FAILURE = 'REQUEST_ADD_TRANSPORTER_FAILURE';

export const REQUEST_UPDATE_TRANSPORTER = 'REQUEST_UPDATE_TRANSPORTER';
export const REQUEST_UPDATE_TRANSPORTER_SUCCESS = 'REQUEST_UPDATE_TRANSPORTER_SUCCESS';
export const REQUEST_UPDATE_TRANSPORTER_FAILURE = 'REQUEST_UPDATE_TRANSPORTER_FAILURE';

export const REQUEST_DELETE_TRANSPORTER = 'REQUEST_DELETE_TRANSPORTER';
export const REQUEST_DELETE_TRANSPORTER_SUCCESS = 'REQUEST_DELETE_TRANSPORTER_SUCCESS';
export const REQUEST_DELETE_TRANSPORTER_FAILURE = 'REQUEST_DELETE_TRANSPORTER_FAILURE';

export const REQUEST_ADD_TRANSPORTER_DETAIL = 'REQUEST_ADD_TRANSPORTER_DETAIL';
export const REQUEST_ADD_TRANSPORTER_DETAIL_SUCCESS = 'REQUEST_ADD_TRANSPORTER_DETAIL_SUCCESS';
export const REQUEST_ADD_TRANSPORTER_DETAIL_FAILURE = 'REQUEST_ADD_TRANSPORTER_DETAIL_FAILURE';

export const REQUEST_DELETE_TRANSPORTER_DETAIL = 'REQUEST_DELETE_TRANSPORTER_DETAIL';
export const REQUEST_DELETE_TRANSPORTER_DETAIL_SUCCESS = 'REQUEST_DELETE_TRANSPORTER_DETAIL_SUCCESS';
export const REQUEST_DELETE_TRANSPORTER_DETAIL_FAILURE = 'REQUEST_DELETE_TRANSPORTER_DETAIL_FAILURE';

export const REQUEST_TRANSPORTERS_PRINT = 'REQUEST_TRANSPORTERS_PRINT';
export const REQUEST_TRANSPORTERS_PRINT_FAILURE = 'REQUEST_TRANSPORTERS_PRINT_FAILURE';
export const REQUEST_TRANSPORTERS_PRINT_SUCCESS = 'REQUEST_TRANSPORTERS_PRINT_SUCCESS';
